module.exports = __webpack_public_path__ + "img/denglu.9d1fadf2.png";